import { instance } from "./base.api";

const endpoint = "/paquetes";

export const product = {
  getAll: (page: number = 1, limit: number = 2000, search?: string) => {
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    });

    if (search && search.trim()) {
      params.set("search", search.trim());
    }

    return instance.get(`${endpoint}?${params.toString()}`);
  },
  getById: (id: number) => {
    return instance.get(`${endpoint}/${id}`);
  },
  create: (productData: any) => {
    return instance.post(endpoint, productData);
  },
  update: (id: number, productData: any) => {
    return instance.put(`${endpoint}/${id}`, productData);
  },
  updateInvoices: (id: string, productData: any) => {
    return instance.put(`${endpoint}/${id}/invoices`, productData);
  },
  delete: (id: number) => {
    return instance.delete(`${endpoint}/${id}`);
  },
  // PAGOS
  createPago: (paqueteId: number, pagoData: any) => {
    return instance.post(`${endpoint}/${paqueteId}/pagos`, pagoData);
  },
  updatePago: (paqueteId: number, pagoId: number, pagoData: any) => {
    return instance.put(`${endpoint}/${paqueteId}/pagos/${pagoId}`, pagoData);
  },
  deletePago: (paqueteId: number, pagoId: number) => {
    return instance.delete(`${endpoint}/${paqueteId}/pagos/${pagoId}`);
  },
  // PASAJEROS
  createPasajero: (paqueteId: number, pasajeroData: any) => {
    return instance.post(`${endpoint}/${paqueteId}/pasajeros`, pasajeroData);
  },
  updatePasajero: (paqueteId: number, pasajeroId: number, pasajeroData: any) => {
    return instance.put(`${endpoint}/${paqueteId}/pasajeros/${pasajeroId}`, pasajeroData);
  },
  deletePasajero: (paqueteId: number, pasajeroId: number) => {
    return instance.delete(`${endpoint}/${paqueteId}/pasajeros/${pasajeroId}`);
  },
  // BRIDGE A PROVEEDORES
  syncProviders: (paqueteId: number) => {
    return instance.post(`${endpoint}/${paqueteId}/sync-providers`);
  },
  // RESTORE
  restoreBudget: (paqueteId: number) => {
    return instance.post(`/providers/restore-budget/${paqueteId}`);
  },
  // ESTADOS
  updateEstado: (paqueteId: number, estado: string, usuario?: string) => {
    return instance.patch(`${endpoint}/${paqueteId}/estado`, { estado, usuario });
  },
  updatePendientePago: (paqueteId: number, pendientePago: boolean) => {
    return instance.patch(`${endpoint}/${paqueteId}/pendiente-pago`, { pendiente_pago: pendientePago ? 1 : 0 });
  },
  getStats: () => {
    return instance.get(`${endpoint}/stats`);
  },
  // OPERACIONES MASIVAS
  bulkUpdateEstado: (ids: number[], estado: string, usuario?: string) => {
    return instance.patch(`${endpoint}/bulk-estado`, { ids, estado, usuario });
  },
  recalcularComision: (id: number) => {
    return instance.patch(`${endpoint}/${id}/recalcular-comision`);
  },
  recalcularTodasComisiones: () => {
    return instance.post(`${endpoint}/recalcular-comisiones-masivo`);
  },
  // TIPO DE CAMBIO
  getTipoCambioHoy: () => {
    return instance.get("/tipo-cambio/hoy");
  },
  getTipoCambioHistory: () => {
    return instance.get("/tipo-cambio/history");
  },
  updateTipoCambio: (valor: number, moneda: string = "USD") => {
    return instance.post("/tipo-cambio", { valor, moneda });
  },
  // ANALYTICS DASHBOARD
  getAnalytics: (month: number, year: number, vendedor?: string) => {
    const params = new URLSearchParams({
      month: String(month),
      year: String(year),
    });
    if (vendedor) params.set("vendedor", vendedor);
    return instance.get(`${endpoint}/analytics?${params.toString()}`);
  },
};
